"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productHelper = void 0;
const enums_1 = require("./enums");
const moment = require("moment");
exports.productHelper = {
    isWolfMotor(interaction) {
        return interaction.product === enums_1.ProductsEnum.WOLF_MOTOR;
    },
    isAnnualMonthlyPremiumType(interaction) {
        return interaction.factors.premiumType === enums_1.AnnualPolicyPremiumTypeEnum.MONTHLY;
    },
    isMultipleProduct(policies) {
        if (policies.length > 1) {
            for (const product of policies.map((policy) => policy.interaction.product)) {
                if (product !== product[0]) {
                    return true;
                }
            }
        }
        return false;
    },
    includesWolfMotorProduct(policies) {
        return policies.map((policy) => policy.interaction.product).includes(enums_1.ProductsEnum.WOLF_MOTOR);
    },
    includesNonExpiredWolfMotorPolicies(policies) {
        return policies
            .filter((policy) => moment(policy.endDate).isSameOrAfter(moment()))
            .map((policy) => policy.interaction.product)
            .includes(enums_1.ProductsEnum.WOLF_MOTOR);
    },
    getNewBusinessUrl(product) {
        return `/journey/show/product/${product.valueOf().replace("PropositionFalcon", "").replace("PropositionWolf", "Annual")}/process/nb`;
    },
    getNewBusinessFromDashboardUrl(product) {
        return `${this.getNewBusinessUrl(product)}/dashboardEntryPage`;
    },
    decodeShortenedProduct(shortenedProduct) {
        let product;
        if (shortenedProduct === "AnnualMotorInsurance") {
            product = enums_1.ProductsEnum.WOLF_MOTOR.valueOf();
        }
        else {
            product = shortenedProduct;
        }
        return product;
    },
    getInteractionPolicyData(interaction) {
        return interaction.polarisPolicyData;
    },
    getActiveAnnualMotorPolicy(policies, policyNumber) {
        return policies.filter(p => this.includesNonExpiredWolfMotorPolicies([p]) && p.policyNumber === policyNumber)[0];
    },
    isPolicyInRenewalWindow(policy) {
        return moment.utc() >= moment.utc(policy.endDate, moment.ISO_8601).startOf('day').subtract(31, 'days');
    },
    isActivePolicy(policy) {
        return moment.utc(policy.endDate, moment.ISO_8601).isSameOrAfter(moment(), 'day');
    },
    getOneExpectedElement(elements) {
        if (elements.length !== 1) {
            throw new Error(`There must be exactly one element! But found ${elements.length}!`);
        }
        return elements[0];
    },
    atLeastOneActivePolicy(policies) {
        return policies.some((policy) => {
            return exports.productHelper.isActivePolicy(policy);
        });
    },
    parseProductName(productName) {
        const productEnumValues = [
            enums_1.ProductsEnum.WOLF_MOTOR,
            enums_1.ProductsEnum.DRIVE_AWAY
        ];
        const matchedProduct = productEnumValues.find(product => product.toString() === productName);
        return matchedProduct !== null && matchedProduct !== void 0 ? matchedProduct : undefined;
    },
    isDirectDebit(interaction) {
        var _a, _b, _c;
        return ((_a = interaction.paymentDetails) === null || _a === void 0 ? void 0 : _a.paymentType) === 'directDebit' || ((_c = (_b = interaction.paymentDetails) === null || _b === void 0 ? void 0 : _b.directDebitDetails) === null || _c === void 0 ? void 0 : _c.detailsVerified) === true;
    },
    isWolfMotorByProduct(product) {
        return product === enums_1.ProductsEnum.WOLF_MOTOR;
    }
};
//# sourceMappingURL=productHelper.js.map